<template>
  <GestionReporteAcumuladoAuditor />
</template>
<script>
import GestionReporteAcumuladoAuditor from "./components/GestionReporteAcumuladoAuditor";
export default {
  components: { GestionReporteAcumuladoAuditor },
};
</script>